import { WS_URL } from "../config";

type PeopleRealtimeData = {
  stream_id: string;
  time: string;
  count: number;
};

type Callback = (data: PeopleRealtimeData) => void;

class PeopleWebSocketService {
  private sockets: Record<string, WebSocket> = {};

  connect(streamId: string, onData: Callback) {
    if (this.sockets[streamId]) {
      console.log(`Já conectado ao WebSocket de ${streamId}`);
      return;
    }
    const wsUrl = `${WS_URL}/people_count/${streamId}`;
    console.log("Conectando ao WebSocket:", wsUrl);
    const ws = new WebSocket(wsUrl);
    ws.onopen = () => console.log(`WebSocket aberto para ${streamId}`);
    ws.onerror = (e) => console.error(`Erro no WebSocket de ${streamId}`, e);
    ws.onclose = () => console.log(`WebSocket fechado para ${streamId}`);
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (typeof data === "object" && data !== null && "time" in data && "count" in data) {
        onData({ ...data, stream_id: streamId });
      }
    };
    this.sockets[streamId] = ws;
  }

  disconnect(streamId: string) {
    if (this.sockets[streamId]) {
      this.sockets[streamId].close();
      delete this.sockets[streamId];
    }
  }

  disconnectAll() {
    Object.keys(this.sockets).forEach((id) => this.disconnect(id));
  }
}

export const peopleWebSocketService = new PeopleWebSocketService();